import AccordionTabs from './AccordionTabs';
import { scrollTo } from './utils/general';

window.addEventListener('DOMContentLoaded', () => {

  // init accordion-tabs:
  if (document.querySelector('.accordion-tabs')) {
    const accordionTabs = new AccordionTabs(document.querySelector('.accordion-tabs'), {
      onInit: (accordionTabs, mode) => {
        if (mode === 'mobile') {
          // auto-close all tabs
          accordionTabs.closeAll();
        }
      },
      onModeChange: (accordionTabs, mode) => {
        if (mode === 'desktop') {
          // auto-switch to first tab
          accordionTabs.switchTo(0);
        } else if (mode === 'mobile') {
          // auto-close all tabs
          accordionTabs.closeAll();
        }
      }
    });

    // activate specific accordionTab block and scroll to it
    Array.from(document.querySelectorAll('[data-scroll-to-block]')).forEach(linkEl => {
      linkEl.addEventListener('click', e => {
        e.preventDefault();
        const blockId = linkEl.getAttribute('data-scroll-to-block');
        accordionTabs.switchTo(blockId);
        scrollTo('.accordion-tabs');
      }, false);
    });

  }

});
